export type ClientPortalDataScopeInput = {
    tenantId?: unknown;
    clientId?: unknown;
    previewClientId?: unknown;
};

function normalizeScopePart(value: unknown): string {
    return String(value || '').trim();
}

export function buildClientPortalDataScopeKey(input: ClientPortalDataScopeInput): string {
    const tenantId = normalizeScopePart(input.tenantId);
    const clientId = normalizeScopePart(input.clientId);
    const previewClientId = normalizeScopePart(input.previewClientId);
    return `${tenantId}|${clientId}|${previewClientId ? `preview:${previewClientId}` : 'live'}`;
}

export function isCurrentClientPortalDataScope(currentScopeKey: string | null | undefined, requestedScopeKey: string): boolean {
    return Boolean(requestedScopeKey) && currentScopeKey === requestedScopeKey;
}
